/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TypePolicies } from '@apollo/client';
import { uniqBy } from 'lodash';
import { APOLLO_CLEAR_CACHE_KEY } from '../cache.hooks';

const ChatCacheTypePolicies: TypePolicies = {
  Query: {
    fields: {
      listChatMessages: {
        keyArgs: ['input', ['chatId', 'threadId']],
        merge: (existing, incoming, { variables }) => {
          if (variables && variables[APOLLO_CLEAR_CACHE_KEY]) {
            return incoming;
          }

          if (existing?.items) {
            const items = uniqBy(
              [...existing.items, ...incoming.items],
              '__ref'
            );
            return {
              ...existing,
              items,
              nextCursor: incoming.nextCursor,
              prevCursor: incoming.prevCursor,
            };
          } else {
            return incoming;
          }
        },
      },
    },
  },
  ChatMessage: {
    fields: {
      attachments: {
        merge: (existing, incoming) => {
          return incoming ?? existing ?? [];
        },
      },
      replies: {
        merge: (existing, incoming) => {
          // since GetChatMessage does not return replies, we want to only update the
          // `replies` field there are incoming replies so that we don't remove
          // replies from the list call.  We also need to fall back to `null` because
          // on initially the `existing` value is undefined, which is not a valid value
          // in the schema.
          return incoming ?? existing ?? null;
        },
      },
      totalReplies: {
        merge: (existing, incoming) => {
          // since GetChatMessage does not return totalReplies, we want to only update the
          // `totalReplies` field there is an incoming value so that we don't remove
          // totalReplies.  We also need to fall back to `null` because on initially the `existing`
          // value is undefined, which is not a valid value in the schema.
          return incoming ?? existing ?? null;
        },
      },
    },
  },
};

export { ChatCacheTypePolicies };
